import { Group, HoverCard, Text } from '@mantine/core';
import { HiOutlineInformationCircle } from 'react-icons/hi';
import { ForwardedRef, forwardRef, ReactNode } from 'react';
import StyledInputLabel from '@/components/StyledInputFields/StyledInputLabel.tsx';
import StyledButton from './StyledButton/StyledButton';

type props = {
  label: string | ReactNode;
  hoverText: string;
  openDelay?: number;
};

const InputLabelWithHoverCard = forwardRef(
  ({ label, hoverText, openDelay = 250 }: props, ref: ForwardedRef<HTMLSpanElement>) => {
    const labelElement =
      typeof label === 'string' ? (
        <StyledInputLabel style={{ marginBottom: 0 }}>{label}</StyledInputLabel>
      ) : (
        label
      );
    return (
      <Group gap={'2px'} wrap={'nowrap'} pos={'relative'} display={'inline-flex'}>
        {labelElement}
        <HoverCard width={300} shadow="md" position={'top'} openDelay={openDelay}>
          <HoverCard.Target>
            <span ref={ref}>
              <StyledButton size={'sm'} variant={'subtleIcon'} aria-label="Show field help" w={'20px'} h={'20px'}>
                <HiOutlineInformationCircle size={14} color={'#BABABA'} />
              </StyledButton>
            </span>
          </HoverCard.Target>
          <HoverCard.Dropdown>
            <Text size="sm">{hoverText}</Text>
          </HoverCard.Dropdown>
        </HoverCard>
      </Group>
    );
  },
);

InputLabelWithHoverCard.displayName = 'InputLabelWithHoverCard';

export default InputLabelWithHoverCard;
